const forgeUiComponent = require('../framework/ui-component');
const SnapScroll = require('../mixins/snapscroll');

var MiniSchedule = forgeUiComponent('MiniSchedule', {}, function MiniScheduleConstructor() {
  var self = this;
  const snapScroller = self.element.querySelector('.SnapScroll');
  const snapScrollContent = self.element.querySelector('.SnapScroll-content');
  const snapScrollOptions = {
    clipWidth: this.options.clipWidth || 200,
    offsetDistance: this.options.offsetDistance || 20
  };
  new SnapScroll(snapScroller, snapScrollContent, snapScrollOptions);
});

module.exports = MiniSchedule;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/minischedule.js
// module id = 60
// module chunks = 0